"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = exports.withTheme = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _constants = require("./constants");

var _ThemeContext = require("./ThemeContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line arrow-parens
var withTheme = function withTheme(WrappedComponent) {
  var ComponentWithTheme =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ComponentWithTheme, _React$Component);

    function ComponentWithTheme(props) {
      var _this;

      _classCallCheck(this, ComponentWithTheme);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentWithTheme).call(this, props));
      _this.compileWithTheme = _this.compileWithTheme.bind(_assertThisInitialized(_this));
      return _this;
    }
    /* :: compileWithTheme: string => string */


    _createClass(ComponentWithTheme, [{
      key: "compileWithTheme",
      value: function compileWithTheme(className) {
        var theme = this.context.theme;
        return (0, _classnames["default"])(className, _constants.THEME_CLASSNAMES[theme]);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, _extends({}, this.props, {
          compileWithTheme: this.compileWithTheme
        }));
      }
    }]);

    return ComponentWithTheme;
  }(React.Component); // React 15.x compatibility fallback. We'll remove it later.


  _defineProperty(ComponentWithTheme, "displayName", "withTheme(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));

  if (_constants.IS_LEGACY_CONTEXT) {
    ComponentWithTheme.contextTypes = {
      theme: function theme() {
        return null;
      }
    };
  } else {
    // -ignore
    ComponentWithTheme.contextType = _ThemeContext.ThemeContext;
  }

  return (0, _hoistNonReactStatics["default"])(ComponentWithTheme, WrappedComponent);
};

exports.withTheme = withTheme;

var useThemeHook = function useThemeHook(className) {
  // -ignore
  var _React$useContext = React.useContext(_ThemeContext.ThemeContext),
      theme = _React$useContext.theme;

  return (0, _classnames["default"])(className, _constants.THEME_CLASSNAMES[theme]);
}; // React 15.x compatibility fallback. We'll remove it later.


var useTheme = _constants.IS_LEGACY_CONTEXT ? function () {
  throw new Error("Your react version isn't supported");
} : useThemeHook;
exports.useTheme = useTheme;